import { render, staticRenderFns } from "./game_selector.vue?vue&type=template&id=185e5a42&scoped=true&lang=pug&"
import script from "./game_selector.vue?vue&type=script&lang=js&"
export * from "./game_selector.vue?vue&type=script&lang=js&"
import style0 from "./game_selector.vue?vue&type=style&index=0&id=185e5a42&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e5a42",
  null
  
)

export default component.exports